import {
  LOAD_FILE_LIST_SUCCESS,
  SAVE_FILE_ID,
  WIPE_FILE_LIST, DELETE_FILE_SUCCESS
} from "constants/ActionTypes";

const INIT_STATE = {
  myFileList: [],
  selectedFileID: localStorage.getItem('file_id'),
  update:false,
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case LOAD_FILE_LIST_SUCCESS: {
      return {
        ...state,
        update:false,
        myFileList: action.payload
      }
    }
    case SAVE_FILE_ID: {
       return {
        ...state,
        selectedFileID: action.payload
      }
    }
    case WIPE_FILE_LIST: {
      return {
       ...state,
       myFileList: []
     }
   }

   case DELETE_FILE_SUCCESS: {
    
     return{
       ...state,
      update:true,
     }
   }


    

    default: {// need this for default case
      return state
    }

  }

}
